const types = {
    1: "1: 4820",
    2: "2: 4850/48100",
    3: "3: 3.4kWh",
    4: "4: 5.8kWh",
    5: "5: 6.8kWh",
    6: "6: 10225",
    7: "7: GD305_4820",
    8: "8: GD305_4850/48100",
    9: "9: GD305_3.4kWh",
    10: "10: GD305_5.8kWh",
    11: "11: GD305_6.8kWh",
    12: "12: GD305_32Series",
    13: "13: EnergyPort_GD",
    14: "14: EnergyPort_STM",
    15: "15: GD105_1818",
    16: "16: STACK",
    17: "17: KARTING",
    18: "18: MOS_RGV",
    19: "19: MOS_RV",
    20: "20: GD305_1818_AS",
    21: "21: GD305_1818_HV_BMS",
    22: "22: BalconyEnergyStorage",
    23: "23: CommunicationBoard",
    24: "24: ICES_BCU",
    25: "25: ICES_RTC",
    26: "26: ICES_EMS",
    27: "27: 5000S_Master",
    28: "28: 5000S_Slave",
    29: "29: ESSEM_ECO",
    30: "30: MosterControl"
}

const inverterProtocolTypes = {
    'Thinkpower': {
        0: '0: Universal Firmware',
        1: '1: Communication Board Firmware',
        2: '2: Control Board Firmware',
    },
    'Sungery': {
        0: '0: Universal Firmware',
        1: '1: Communication Board Firmware',
        2: '2: Control Board Firmware',
    },
    'Senergy': {
        0: '0: DSP1',
        1: '1: DSP2',
        2: '2: DSP3',
        3: '3: CSB',
    },
    "Uhome-SinglePhase": {
        0: "0: Master DSP",
        1: "1: Slave DSP",
    },
    "Uhome-ThreePhase": {
        0: "0: Master DSP",
        1: "1: Slave DSP",
        2: "2: ARM"
    }
}

const burningTypes = {
    1: "1: Master-APP",
    2: "2: Master-BOOT",
}

const burningTypesForEnergyPort = {
    1: "1: Master-APP",
    2: "2: Master-BOOT",
    7: "7: Second-APP",
    8: "8: Second-BOOT",
}

const burningTypesForAllInOneC10kW = {
    1: "1: APP",
    2: "2: BOOT",
    3: "3: stm32 bootloader",
    4: "4: stm32 application", 
    5: "5: 280049 application",
    6: "6: 280049 flash",
}

const all = {
    burningTypes,
    burningTypesForEnergyPort,
    burningTypesForAllInOneC10kW,
    types,
    inverterProtocolTypes,
};

export default all;